export default defineNuxtPlugin(() => {
  addRouteMiddleware('auth-client', to => {
    const allowBootstrapRoutes = ['/redirect', '/auto-login', '/token-expired']

    if (allowBootstrapRoutes.includes(to.path)) return

    const hasToken = !!localStorage.getItem('access_token')
    const hasUser = !!useState('auth.user.info').value

    if (to.meta.unauthenticatedOnly && (hasToken || hasUser)) {
      return navigateTo('/', { replace: true })
    }
  }, { global: true })
})